export enum BookingCalendarViewMode {
  AllPassengers = "AllPassengers",
  WithBookings = "WithBookings",
  WithoutBookings = "WithoutBookings",
}
